// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-grid[data-v-76f61e78]{height:100%;width:100%}.c-grid .define[data-v-76f61e78]{display:none!important;position:fixed;top:-300px;left:-300px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
